import React from "react";
import styled from "styled-components";
import {
  useTranslate,
  List,
  Create,
  TextInput,
  Edit,
  SimpleForm,
  TextField,
  Datagrid,
  EditButton,
  useRedirect,
} from "react-admin";

const Container = styled.div`
  width: 100%;
  padding: 24px 24px 48px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
`;

const Content = styled.div`
  width: 100%;
  max-width: 1200px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
`;

const Title = styled.h2`
  margin: 0;
  color: #212121;
  font-size: 24px;
  line-height: 1.2;
`;

const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
`;

const ListCard = styled.div`
  background: #fff;
  border-radius: 12px;
  border: 1px solid #eeeeee;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06);
  padding: 8px 12px;
`;

const CreateLink = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: #ed4e2a;
  color: #fff;
  padding: 10px 16px;
  border-radius: 10px;
  text-decoration: none;
  font-weight: 600;
  font-size: 14px;
  box-shadow: 0 6px 16px rgba(237, 78, 42, 0.3);
  transition: transform 160ms ease, box-shadow 160ms ease;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 8px 20px rgba(237, 78, 42, 0.35);
  }
`;

const validateOpening = (values: any) => {
  const errors: any = {};

  if (!values.title) {
    errors.title = ["O título é obrigatório!"];
  }

  if (!values.openTime) {
    errors.openTime = ["O horário de abertura é obrigatório!"];
  }

  if (!values.closeTime) {
    errors.closeTime = ["O horário de fechamento é obrigatório!"];
  }

  return errors;
};

export const OpeningsList = (props: any) => {
  const translate = useTranslate();
  return (
    <List
      {...props}
      title={translate(`custom.menu.${props.resource}`)}
      exporter={false}
      bulkActionButtons={false}
      pagination={false}
      actions={false}
    >
      <Container>
        <Content>
          <HeaderRow>
            <Title>{translate(`custom.menu.${props.resource}`)}</Title>
            <Actions>
              <CreateLink href="#/opening/create">
                + Criar horário
              </CreateLink>
            </Actions>
          </HeaderRow>
          <ListCard>
            <Datagrid rowClick="edit">
              <TextField source="title" label="Dias" />
              <TextField source="openTime" label="Abertura" sortable={false} />
              <TextField
                source="lunchStartTime"
                label="Inicio Almoço (opcional)"
                sortable={false}
              />
              <TextField
                source="lunchEndTime"
                label="Fim almoço (opcional)"
                sortable={false}
              />
              <TextField source="closeTime" label="Encerramento" sortable={false} />
              <EditButton />
            </Datagrid>
          </ListCard>
        </Content>
      </Container>
    </List>
  );
};

export const OpeningsEdit = (props: any) => {
  const translate = useTranslate();

  return (
    <Edit
      undoable={false}
      {...props}
      title={translate(`custom.menu.${props.resource}`)}
    >
      <SimpleForm validate={validateOpening}>
        <TextInput source="title" label="Dias" />
        <TextInput source="openTime" label="Abertura" />
        <TextInput source="lunchStartTime" label="Inicio Almoço (opcional)" />
        <TextInput source="lunchEndTime" label="Fim almoço (opcional)" />
        <TextInput source="closeTime" label="Encerramento" />
      </SimpleForm>
    </Edit>
  );
};

export const OpeningsCreate = (props: any) => {
  const translate = useTranslate();
  const redirect = useRedirect();

  return (
    <Create
      {...props}
      title={translate(`custom.menu.${props.resource}`)}
      onSuccess={() => {
        redirect("/opening");
      }}
    >
      <SimpleForm validate={validateOpening}>
        <TextInput source="title" label="Dias" />
        <TextInput source="openTime" label="Abertura" />
        <TextInput source="lunchStartTime" label="Inicio Almoço (opcional)" />
        <TextInput source="lunchEndTime" label="Fim almoço (opcional)" />
        <TextInput source="closeTime" label="Encerramento" />
      </SimpleForm>
    </Create>
  );
};
